// Mirror of the backend's Pydantic schemas. Keep in sync with backend/routes/*.
// Allowed durations for time blocks and recurring patterns. Backend allows any
// positive multiple of 15 up to 8 hours; we pick a sensible UI subset here so
// pickers don't get unwieldy. Keep this list in sync with what the dropdowns
// in BlockEditor / RecurringPatternEditor present.
export const ALLOWED_BLOCK_MINUTES = [15, 30, 45, 60, 75, 90, 105, 120];
